import type { KeyedMutator } from 'swr'
import useSWR from 'swr'
import { useApiWrapperWithErrorValidation } from 'shared/hooks/use-api-wrapper-with-error-validation'
import { RequestMethodsEnum } from 'shared/hooks/use-api-wrapper-with-error-validation/types'
import { COURSE_THEMES_API } from '../api/themes-api'
import type { CourseThemeInterface } from '../types/theme-interface'

interface UseThemesResult {
  themes: CourseThemeInterface[] | undefined
  isLoading: boolean
  mutate: KeyedMutator<CourseThemeInterface[]>
}

export default function useThemes(
  { allowFetch }: { allowFetch: boolean } = { allowFetch: true },
): UseThemesResult {
  const { fetcher, isFetching } = useApiWrapperWithErrorValidation<
    RequestMethodsEnum,
    CourseThemeInterface[]
  >({
    method: RequestMethodsEnum.get,
  })

  const { data: themes, mutate } = useSWR<CourseThemeInterface[]>(() => {
    if (allowFetch) return `${COURSE_THEMES_API}/list`
    return null
  }, fetcher)

  return {
    themes,
    isLoading: isFetching,
    mutate,
  }
}
